var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHuntingtonLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_884_1472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 4.71308V13.319C15.974 13.5273 15.8569 13.6966 15.6878 13.8138L13.9577 14.8163V3.22885L15.6878 4.23136C15.8699 4.33551 15.987 4.51779 16 4.71308ZM8.37723 18.0451L10.4195 16.8733V11.2749L8.37723 12.4467V18.0451ZM11.174 7.60342L5.59349 10.8323V16.8733L7.60975 18.0451V12.0561L11.161 9.99902V16.4307L13.2032 15.2719V2.79921L11.161 1.64046V7.60342H11.174ZM7.60975 0L5.59349 1.17176V6.77017L7.60975 5.59841V0ZM10.4065 1.17176L8.36423 0V5.989L4.813 8.04609V1.61442L2.79674 2.78619V15.2459L4.813 16.4046V10.4287L10.4065 7.19982V1.17176ZM0 4.71308V13.319C0.0260163 13.5273 0.143085 13.7096 0.31219 13.8138L2.04227 14.8163V3.22885L0.31219 4.23136C0.143085 4.33551 0.0260163 4.51779 0 4.71308Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_884_1472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 18.0451,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuntingtonLogo);
export default __webpack_public_path__ + "static/media/huntington-logo.bb0318341a45e88cbe1120014ef810be.svg";
export { ForwardRef as ReactComponent };